import { render, staticRenderFns } from "./FavoriteItems.vue?vue&type=template&id=409b2aa7&"
import script from "./FavoriteItems.vue?vue&type=script&lang=ts&"
export * from "./FavoriteItems.vue?vue&type=script&lang=ts&"
import style0 from "./FavoriteItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports